import { VAPID_PUBLIC_KEY } from "@/env";
import apiOffice from "../axios/apiOffice";
import { esIOS, esPWA } from "./deviceService";

let pushEnProceso = false;

export async function solicitarPermisoNotificaciones(userIdParam = null) {
  if (pushEnProceso) return false;
  pushEnProceso = true;

  try {
    // =============================
    // VALIDACIONES BASE
    // =============================
    if (!("serviceWorker" in navigator)) {
      return false;
    }

    if (!("PushManager" in window)) {
      return false;
    }

    if (esIOS() && !esPWA()) {
      return false;
    }

    // =============================
    // USER
    // =============================

    let userId = userIdParam;

    if (!userId) {
      userId = getCurrentUserId();
    }

    if (!userId) {
      return false;
    }

    // =============================
    // PERMISOS
    // =============================
    let permission = Notification.permission;

    if (permission === "default") {
      permission = await Notification.requestPermission();
    }

    if (permission !== "granted") {
      return false;
    }

    // =============================
    // SERVICE WORKER
    // =============================
    const reg = await navigator.serviceWorker.ready;

    let sub = await reg.pushManager.getSubscription();

    // =============================
    // SUSCRIPCIÓN ACTUAL
    // =============================

    const oldEndpoint = localStorage.getItem("push_endpoint");
    const oldUser = localStorage.getItem("push_user");

    // =============================
    // EXPIRACIÓN
    // =============================
    if (sub && sub.expirationTime && sub.expirationTime < Date.now()) {
      await sub.unsubscribe();
      localStorage.removeItem("push_endpoint");
      localStorage.removeItem("push_user");
      sub = null;
    }

    // =============================
    // DETECCIÓN DE ESTADO
    // =============================

    // =============================
    // CREAR SUB SI NO EXISTE
    // =============================
    if (!sub) {
      try {
        sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        });
      } catch (err) {
        return false;
      }
    }

    if (!sub) {
      return false;
    }

    // =============================
    // BACKEND
    // =============================
    const endpoint = sub.endpoint;
    const json = sub.toJSON();

    if (oldEndpoint !== endpoint || oldUser !== String(userId)) {

      try {
        await apiOffice.post("/subscribe", {
          endpoint,
          keys: json.keys,
        });

        localStorage.setItem("push_endpoint", endpoint);
        localStorage.setItem("push_user", String(userId));

      } catch (err) {
        console.error("Error guardando sub:", err);
      }
    }

    return true;
  } finally {
    pushEnProceso = false;
  }
}

// =============================
// HELPERS
// =============================
function getCurrentUserId() {
  try {
    const vuex = JSON.parse(localStorage.getItem("vuex"));
    return vuex?.user?.id || null;
  } catch (e) {
    return null;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}
